export { AssetFieldValueElement } from './web-component';
